"use client";
import WebLayout from "@/components/layout/web/WebLayout";
import ExpertTestimonialsSkeleton from "@/components/web/main/expert testimonials/ExpertTestimonialsSkeleton";
import HomePageExpertsSkeleton from "@/components/web/main/homepage/HomePageExpertsSkeleton";
import HomePageJobsSkeleton from "@/components/web/main/homepage/HomePageJobsSkeleton";
import HomePageOrgsSkeleton from "@/components/web/main/homepage/HomePageOrgsSkeleton";
import LandingSkeleton from "@/components/web/main/landing/LandingSkeleton";
import NewsletterSkeleton from "@/components/web/main/newsletter/NewsletterSkeleton";
import OrganizationTestimonialsSkeleton from "@/components/web/main/organization testimonials/OrganizationTestimonialsSkeleton";
import OurPartnersSkeleton from "@/components/web/main/our partners/OurPartnersSkeleton";
import PartnersSkeleton from "@/components/web/main/partners/PartnersSkeleton";

const loading = () => {
  return (
    <>
      <LandingSkeleton />
      <section>
        <HomePageExpertsSkeleton />
      </section>
      <section className="bg-brandGrey ">
        <ExpertTestimonialsSkeleton />
      </section>
      <section>
        <HomePageJobsSkeleton />
      </section>
      <section>
        <PartnersSkeleton />
      </section>
      <section className="mt-[54px]">
        <HomePageOrgsSkeleton />
      </section>
      <section className="bg-brandGrey">
        <OrganizationTestimonialsSkeleton />
      </section>
      <section>
        <NewsletterSkeleton />
      </section>
      <section className="bg-brandGrey">
        <OurPartnersSkeleton />
      </section>
    </>
  );
};

export default WebLayout(loading, false);
